import React, {useState, useEffect} from 'react';
import categories  from '../categories';
import './Home.css';
const GRID_SIZE = 5;

const Home = () => {
    const [cells, setCells] = useState({});
    // const [bingo, setBingo] = useState(false);
    // const [showCard, setShowCard] = useState(false);
    const [showAlert, setShowAlert] = useState(false);
    const [infoCell, setInfoCell] = useState(null);
    const [showInfo, setShowInfo] = useState(false);

    const emailLink = () => {
  const user = "info";
  const domain = "arcc-cdac.ca";
  const email = `${user}@${domain}`;
    return <a href={`mailto:${email}`}>{email}</a>;
    }


    function initializeCells() {
        const newCells = {};
        const shuffledCategories = [...categories].sort(() => Math.random() - 0.5);
        for (let row = 0; row < GRID_SIZE; row++) {
            for (let col = 0; col < GRID_SIZE; col++) {
                if (row === 2 && col === 2) {
                    newCells[`${row}-${col}`] = { text: '', marked: true };
                }
                // Optionally assign random categories to other cells
                else {
                    const cellIndex = row * GRID_SIZE + col - (row > 2 || (row === 2 && col > 2) ? 1 : 0); // skip center cell
                    const randomCategory = shuffledCategories[cellIndex];
                    newCells[`${row}-${col}`] = { text: randomCategory.text, info: randomCategory.info, marked: false };
                }
            }
        }
        setCells(newCells);
    }

    // const isBingo = React.useCallback(() => {
    //     // Check rows
    //     for (let row = 0; row < GRID_SIZE; row++) {
    //         let rowBingo = true;
    //         for (let col = 0; col < GRID_SIZE; col++) {
    //             if (!cells[`${row}-${col}`]?.marked) {
    //                 rowBingo = false;
    //                 break;
    //             }
    //         }
    //         if (rowBingo) return true;
    //     }   
    //     // Check columns
    //     for (let col = 0; col < GRID_SIZE; col++) {
    //         let colBingo = true;
    //         for (let row = 0; row < GRID_SIZE; row++) {
    //             if (!cells[`${row}-${col}`]?.marked) {
    //                 colBingo = false;
    //                 break;
    //             }
    //         }
    //         if (colBingo) return true;
    //     }
    //     // Check diagonals
    //     let diag1Bingo = true;
    //     let diag2Bingo = true;  
    //     for (let i = 0; i < GRID_SIZE; i++) {
    //         if (!cells[`${i}-${i}`]?.marked) {
    //             diag1Bingo = false;
    //         }   
    //         if (!cells[`${i}-${GRID_SIZE - 1 - i}`]?.marked) {
    //             diag2Bingo = false;
    //         }
    //     }
    //     if (diag1Bingo || diag2Bingo) return true;
    //     return false;
    // }, [cells]);

    function initGenerateCard(){
        const hasMarkedCells = Object.values(cells).filter(cell => cell.marked).length > 1;
        
        if(hasMarkedCells){ 
            setShowAlert(true);
            return;
        } 
        generateCard();
        // setShowCard(true);
    }

    function generateCard() {
        initializeCells();
        // setBingo(false);
    }


    // useEffect(() => {
    //       setBingo(isBingo());
    // }, [cells, isBingo]);

    useEffect(() => {
        // if(localStorage.getItem('bingoCells')){
        //     setShowCard(true);
        //     // setCells(JSON.parse(localStorage.getItem('bingoCells')));
        // }
    }, []);

    // Helper to add the class to the button in the center
    function getButtonClass(row, col) {
        return (row === 2 && col === 2) || cells[`${row}-${col}`]?.marked ? 'pink-circle-btn' : '';
    }

    function handleClick(row, col) {
        const key = `${row}-${col}`;
        const updatedCells = { ...cells, [key]: { ...cells[key], marked: !cells[key]?.marked } };
        setCells(updatedCells);
        localStorage.setItem('bingoCells', JSON.stringify(updatedCells));
    }

    function handleInfoClick(cell){
        setInfoCell(cell);
        setShowInfo(true);
    }

    return (
        <>
            <img className="top-logo" alt="arcc-logo" src="/arrc_logo_eng.jpg" />
            <h4 className='top-title'> Play the ARCC "UPC BINGO" game!</h4>
            <p className='intro-text'>Make a Bingo card and pick a website to begin playing. Here’s  
                <a href='https://www.arcc-cdac.ca/media/2021/09/list-anti-choice-groups-CPCs-only.pdf' target="_blank" rel="noopener noreferrer"> our list of UPCs </a>— unregulated pregnancy centres.
                Fill in the UPC details on your card, take a screenshot, and send it to {emailLink()}! <br />
                You will gain our admiration for your keen eyes, and some prizes too.
                <br /><br />Help us raise awareness about these <a href="https://www.arcc-cdac.ca/media/cpc-brochure-trifold.pdf" target="_blank" rel="noopener noreferrer">deceptive centres</a> by sharing our Bingo card link on social media with the hashtag <b>#UPCBingo</b>!
            </p>
            <button type="button" className='main-button' onClick={initGenerateCard}> Make a card </button>
            {cells && <div className='container'>
                <div className="card-header">
                    <h4 className='title1'>UNREGULATED PREGNANCY CENTRE</h4>
                    <div className='input-group'>
                        <label className='input-label'>UPC URL: </label>
                        <input className='input' type="text"></input>
                    </div>
                    <div className='input-group'>
                        <label className='input-label'>UPC Name: </label>
                        <input className='input' type="text"></input>
                    </div>
                    <div className='input-group'>
                        <label className='input-label'>City, Province: </label>
                        <input className='input' type="text"></input>
                    </div>
  
                    <h2 className='title2'>BINGO</h2>
                </div>
                <div className="bingo-grid">
                    {[...Array(GRID_SIZE)].map((_, rowIdx) =>
                        [...Array(GRID_SIZE)].map((_, colIdx) => (
                            <div className="bingo-cell" key={`${rowIdx}-${colIdx}`}>
                                <button
                                    className={`bingo-btn ${getButtonClass(rowIdx, colIdx)}`}
                                    onClick={handleClick.bind(null, rowIdx, colIdx)}
                                >
                                    <span style={{ zIndex: 2, position: 'relative' }} >
                                        {cells[`${rowIdx}-${colIdx}`]?.text ? cells[`${rowIdx}-${colIdx}`].text : ''}
                                    </span>
                                    {(rowIdx === 2 && colIdx === 2) && (
                                        <img className="center-logo" alt="arcc-logo" src="/CaptureLogo.JPG" />
                                    )}
                                </button>
                                {(cells[`${rowIdx}-${colIdx}`]?.info) && 
                                <button type='button' className="info-circle" 
                                    onClick={() => handleInfoClick(cells[`${rowIdx}-${colIdx}`])} >
                                    i
                                </button>}
                            </div>
                        ))
                    )}
                </div>
                <div className='footer'>
                    <div className='footer-section footer-left'>
                        <img className="footer-logo" alt="arcc-logo" src="/arrc_logo_eng.jpg" />
                        <a href="https://www.arcc-cdac.ca/" target="_blank" rel="noreferrer">www.arcc-cdac.ca</a>
                    </div>
                    <div className='footer-section footer-center'> 
                        <div>Score a bingo (line, diagonal or full card) by finding these problems on the website of an anti-abortion pregnancy centre. 
                            Send the card to {emailLink()} for prizes.<br/>Scan the QR code to visit the ARCC Resources page for a list of UPCs. </div>
                        <div className='share-text'>Share your card on social media with #UPCBingo</div>
                    </div>
                    <div className='footer-section footer-right'>
                         <img className="footer-logo" alt="arcc-qrcode" src="/qrcode.jpg" />
                    </div>
                </div>
            </div>} 
        {showAlert && <div className="alert">
            <div>Generating a new card will reset your current progress. Do you want to continue?</div>
                <div className="alert-buttons">
                    <button className='alert-button' onClick={() => { setShowAlert(false); generateCard(); }}>Yes</button>
                    <button className='alert-button'  onClick={() => setShowAlert(false)}>No</button>
                </div>
            </div>}

            {showInfo && <div className="alert">
                    <button type='button' className='close-button' onClick={() => setShowInfo(false)}>✕</button>
                    <div className='info-content'>
                        <div> <div className="info-circle in-alert">i</div> <b>{infoCell.text}</b>: </div>
                        <div>{infoCell.info}</div>
                    </div>
            </div>}
    </>
    );
};

export default Home;